import { render, staticRenderFns } from "./Obi.vue?vue&type=template&id=0c7d9af5&"
import script from "./Obi.vue?vue&type=script&lang=js&"
export * from "./Obi.vue?vue&type=script&lang=js&"
import style0 from "./Obi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports